import { ErrorState } from './reducer';

export const createErrorSelector = (action: string) => (state: ErrorState) =>
  state[action];
